module.exports = __webpack_public_path__ + "img/GHS09.b957b89c.webp";